export { default } from './RichTextEditorCustom';
